var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "5",
      "md": "12"
    }
  }, [_c('h1', {
    staticClass: "text-white mb-50"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "FileTextIcon",
      "size": "28"
    }
  }), _vm._v(" Questionários Sociodemográficos ")], 1), _c('p', {
    staticClass: "text-white-50 mb-0 font-small-3"
  }, [_vm._v(" Listagem de alunos que responderam o questionário socioeconômico e ambiental ")])]), _c('b-col', {
    staticClass: "mt-1 mt-lg-0",
    attrs: {
      "lg": "5",
      "md": "8"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.fetchQuestionarios.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar por aluno, responsável, bairro, cidade..."
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.filtro.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "search", $$v);
      },
      expression: "filtro.search"
    }
  })], 1)], 1)], 1), _c('b-col', {
    staticClass: "text-lg-right mt-1 mt-lg-0",
    attrs: {
      "lg": "2",
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "variant": "success",
      "disabled": !_vm.fetchedData.totalItems
    },
    on: {
      "click": _vm.exportarCsv
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "DownloadIcon"
    }
  }), _vm._v(" Exportar CSV ")], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "p-1 mb-0 border-left-primary shadow-none",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', {
    staticClass: "mb-25 font-weight-bolder text-primary"
  }, [_vm._v(" " + _vm._s(_vm.fetchedData.totalItems || 0) + " ")]), _c('span', {
    staticClass: "text-muted font-small-3"
  }, [_vm._v("Total Respondidos")])]), _c('div', {
    staticClass: "avatar bg-light-primary p-50 m-0"
  }, [_c('feather-icon', {
    staticClass: "text-primary",
    attrs: {
      "icon": "UsersIcon",
      "size": "24"
    }
  })], 1)])])], 1), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "p-1 mb-0 border-left-info shadow-none",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', {
    staticClass: "mb-25 font-weight-bolder text-info"
  }, [_vm._v(" " + _vm._s(_vm.totalEscolasRepresentadas) + " ")]), _c('span', {
    staticClass: "text-muted font-small-3"
  }, [_vm._v("Escolas na Página")])]), _c('div', {
    staticClass: "avatar bg-light-info p-50 m-0"
  }, [_c('feather-icon', {
    staticClass: "text-info",
    attrs: {
      "icon": "BookOpenIcon",
      "size": "24"
    }
  })], 1)])])], 1), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "p-1 mb-0 border-left-danger shadow-none",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', {
    staticClass: "mb-25 font-weight-bolder text-danger"
  }, [_vm._v(" " + _vm._s(_vm.totalComHistoricoDengue) + " ")]), _c('span', {
    staticClass: "text-muted font-small-3"
  }, [_vm._v("Relataram Dengue")])]), _c('div', {
    staticClass: "avatar bg-light-danger p-50 m-0"
  }, [_c('feather-icon', {
    staticClass: "text-danger",
    attrs: {
      "icon": "ActivityIcon",
      "size": "24"
    }
  })], 1)])])], 1), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "p-1 mb-0 border-left-success shadow-none",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', {
    staticClass: "mb-25 font-weight-bolder text-success"
  }, [_vm._v(" " + _vm._s(_vm.fetchedData.currentPage || 1) + " / " + _vm._s(_vm.fetchedData.totalPages || 1) + " ")]), _c('span', {
    staticClass: "text-muted font-small-3"
  }, [_vm._v("Página Atual")])]), _c('div', {
    staticClass: "avatar bg-light-success p-50 m-0"
  }, [_c('feather-icon', {
    staticClass: "text-success",
    attrs: {
      "icon": "CheckCircleIcon",
      "size": "24"
    }
  })], 1)])])], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Escola")]), _c('v-select', {
    attrs: {
      "options": _vm.escolaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as escolas"
    },
    on: {
      "input": _vm.onEscolaChange
    },
    model: {
      value: _vm.filtro.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "schoolId", $$v);
      },
      expression: "filtro.schoolId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Turma")]), _c('v-select', {
    attrs: {
      "options": _vm.turmaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as turmas",
      "disabled": !_vm.filtro.schoolId
    },
    on: {
      "input": _vm.fetchQuestionarios
    },
    model: {
      value: _vm.filtro.classroomId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "classroomId", $$v);
      },
      expression: "filtro.classroomId"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex align-items-end",
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v(" Limpar Filtros ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchQuestionarios
    }
  }, [_vm._v(" Filtrar ")])], 1)], 1)], 1), _vm.fetchedData.totalItems ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-1"
  }, [_c('div', {
    staticClass: "text-muted font-small-3"
  }, [_vm._v(" Mostrando "), _c('strong', [_vm._v(_vm._s((_vm.fetchedData.content || []).length))]), _vm._v(" de "), _c('strong', [_vm._v(_vm._s(_vm.fetchedData.totalItems))]), _vm._v(" questionário(s) preenchido(s) ")]), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.fetchedData.totalItems,
      "per-page": _vm.filtro.itemsPerPage
    },
    on: {
      "input": _vm.fetchQuestionarios
    },
    model: {
      value: _vm.filtro.page,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "page", $$v);
      },
      expression: "filtro.page"
    }
  })], 1) : _vm._e(), _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refTable",
    staticClass: "position-relative",
    attrs: {
      "items": _vm.fetchedData.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": "Nenhum questionário encontrado."
    },
    scopedSlots: _vm._u([{
      key: "cell(nomeCompleto)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "font-weight-bold d-block text-primary"
        }, [_vm._v(" " + _vm._s(data.item.nomeCompleto || 'Aluno Não Identificado') + " ")]), data.item.email ? _c('small', {
          staticClass: "text-muted"
        }, [_c('feather-icon', {
          staticClass: "mr-25",
          attrs: {
            "icon": "MailIcon",
            "size": "12"
          }
        }), _vm._v(" " + _vm._s(data.item.email) + " ")], 1) : _vm._e(), data.item.telefone ? _c('small', {
          staticClass: "text-muted ml-50"
        }, [_c('feather-icon', {
          staticClass: "mr-25",
          attrs: {
            "icon": "PhoneIcon",
            "size": "12"
          }
        }), _vm._v(" " + _vm._s(data.item.telefone) + " ")], 1) : _vm._e()])];
      }
    }, {
      key: "cell(escola)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(data.item.escola || '-'))])])];
      }
    }, {
      key: "cell(turma)",
      fn: function fn(data) {
        return [_c('div', [_c('b-badge', {
          staticClass: "font-small-2",
          attrs: {
            "variant": "light-primary"
          }
        }, [_vm._v(" " + _vm._s(data.item.turma || data.item.serie || 'Geral') + " ")]), data.item.turno ? _c('div', {
          staticClass: "text-muted font-small-2 mt-25"
        }, [_vm._v(" Turno: " + _vm._s(data.item.turno) + " ")]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(nomeResponsavel)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "d-block font-weight-bold text-dark"
        }, [_vm._v(" " + _vm._s(data.item.nomeResponsavel || '-') + " ")]), data.item.grauParentesco ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" Parentesco: " + _vm._s(data.item.grauParentesco) + " ")]) : _vm._e(), data.item.telefoneResponsavel ? _c('div', {
          staticClass: "font-small-2 text-muted"
        }, [_c('feather-icon', {
          staticClass: "mr-25",
          attrs: {
            "icon": "PhoneCallIcon",
            "size": "12"
          }
        }), _vm._v(" " + _vm._s(data.item.telefoneResponsavel) + " ")], 1) : _vm._e()])];
      }
    }, {
      key: "cell(localizacao)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "font-small-3 font-weight-bold"
        }, [_vm._v(" " + _vm._s(data.item.bairro || '-') + " ")]), data.item.cidade ? _c('small', {
          staticClass: "text-muted d-block"
        }, [_vm._v(" " + _vm._s(data.item.cidade) + " ")]) : _vm._e(), data.item.cep ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" CEP: " + _vm._s(data.item.cep) + " ")]) : _vm._e()])];
      }
    }, {
      key: "cell(historicoSaude)",
      fn: function fn(data) {
        return [_c('div', [data.item.teveDengue === 'Sim' || data.item.teveDengue === 'true' ? _c('b-badge', {
          staticClass: "mr-25 mb-25",
          attrs: {
            "variant": "light-danger"
          }
        }, [_vm._v(" Dengue ")]) : _vm._e(), data.item.teveChikungunya === 'Sim' || data.item.teveChikungunya === 'true' ? _c('b-badge', {
          staticClass: "mr-25 mb-25",
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v(" Chikungunya ")]) : _vm._e(), data.item.teveZikaVirus === 'Sim' || data.item.teveZikaVirus === 'true' ? _c('b-badge', {
          staticClass: "mr-25 mb-25",
          attrs: {
            "variant": "light-info"
          }
        }, [_vm._v(" Zika ")]) : _vm._e(), data.item.teveDengue !== 'Sim' && data.item.teveDengue !== 'true' && data.item.teveChikungunya !== 'Sim' && data.item.teveChikungunya !== 'true' && data.item.teveZikaVirus !== 'Sim' && data.item.teveZikaVirus !== 'true' ? _c('span', {
          staticClass: "text-muted font-small-2"
        }, [_vm._v(" Nenhum relato ")]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(createdAt)",
      fn: function fn(data) {
        return [_c('small', {
          staticClass: "text-muted"
        }, [_c('feather-icon', {
          staticClass: "mr-25",
          attrs: {
            "icon": "CalendarIcon",
            "size": "12"
          }
        }), _vm._v(" " + _vm._s(_vm.formatarData(data.item.createdAt)) + " ")], 1)];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "variant": "outline-primary",
            "size": "sm",
            "title": "Visualizar Respostas Completas"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirDetalhes(data.item.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-25",
          attrs: {
            "icon": "EyeIcon"
          }
        }), _vm._v(" Ver Respostas ")], 1)];
      }
    }])
  })], 1), _vm.fetchedData.totalItems ? _c('div', {
    staticClass: "d-flex justify-content-end mt-1"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.fetchedData.totalItems,
      "per-page": _vm.filtro.itemsPerPage
    },
    on: {
      "input": _vm.fetchQuestionarios
    },
    model: {
      value: _vm.filtro.page,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "page", $$v);
      },
      expression: "filtro.page"
    }
  })], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "modal-detalhes-questionario",
      "title": "Questionário Sociodemográfico - Respostas Detalhadas",
      "title-class": "font-medium-3 text-primary font-weight-bolder",
      "size": "xl",
      "ok-only": "",
      "ok-title": "Fechar",
      "ok-variant": "secondary",
      "scrollable": ""
    },
    model: {
      value: _vm.modalDetalhesAberto,
      callback: function callback($$v) {
        _vm.modalDetalhesAberto = $$v;
      },
      expression: "modalDetalhesAberto"
    }
  }, [_vm.isLoadingDetalhes ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando respostas..."
    }
  }), _c('p', {
    staticClass: "mt-1 text-muted"
  }, [_vm._v("Carregando dados completos do questionário...")])], 1) : _vm.detalhes ? _c('div', [_c('b-tabs', {
    staticClass: "nav-horizontal",
    attrs: {
      "pills": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Aluno e Escola",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UserIcon"
    }
  }), _vm._v(" Dados do Aluno ")], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Nome Completo:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.nomeCompleto || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Data de Nascimento:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.dataNascimento || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Idade:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.idade ? "".concat(_vm.detalhes.idade, " anos") : '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Sexo:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.sexo || _vm.detalhes.outroSexo || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Raça / Cor:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.raca || _vm.detalhes.outraRaca || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("CPF:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.cpf || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("RG:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.rg || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Telefone / WhatsApp:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.telefone || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("E-mail:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.email || '-'))])])], 1), _c('hr'), _c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "BookOpenIcon"
    }
  }), _vm._v(" Dados Escolares ")], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Escola:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.escola || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Turma:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.turma || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Série / Ano:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.serie || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Turno:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.turno || '-'))])])], 1)], 1)]), _c('b-tab', {
    attrs: {
      "title": "Responsável e Endereço"
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UserCheckIcon"
    }
  }), _vm._v(" Dados do Responsável ")], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Nome do Responsável:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.nomeResponsavel || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Grau de Parentesco:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.grauParentesco || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Nível de Instrução:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.nivelInstrucao || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Telefone do Responsável:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.telefoneResponsavel || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Endereço do Responsável:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.enderecoResponsavel || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Bairro / Cidade:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.bairroResponsavel || '-') + " - " + _vm._s(_vm.detalhes.cidadeResponsavel || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("CEP do Responsável:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.cepResponsavel || 'Não informado (opcional)'))])])], 1), _c('hr'), _c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "MapPinIcon"
    }
  }), _vm._v(" Endereço do Aluno ")], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Logradouro / Endereço Atual:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.enderecoAtual || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Bairro:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.bairro || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Cidade:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.cidade || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("CEP do Aluno:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.cep || 'Não informado'))])])], 1)], 1)]), _c('b-tab', {
    attrs: {
      "title": "Moradia e Família"
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "HomeIcon"
    }
  }), _vm._v(" Estrutura e Habitação ")], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Condição de Moradia:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.condicaoMoradia || _vm.detalhes.outraCondicaoMoradia || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Tipo de Moradia:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.tipoMoradia || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Tipo de Residência:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.tipoResidencia || _vm.detalhes.outroTipoResidencia || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Localização:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.localizacaoMoradia || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Quantidade de Cômodos:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.quantidadeComodos || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Pessoas que moram na casa:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.quantidadePessoasMoram || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "12"
    }
  }, [_c('strong', [_vm._v("Quem mora na residência:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.moradores || '-'))])])], 1)], 1)]), _c('b-tab', {
    attrs: {
      "title": "Bens e Saneamento"
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "DropletIcon"
    }
  }), _vm._v(" Água e Saneamento ")], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Tipo de Abastecimento de Água:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.tipoAbastecimentoAgua || _vm.detalhes.outroAbastecimentoAgua || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Forma de Armazenamento de Água:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.armazenaAgua || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Renda Familiar:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.rendaFamiliar || '-'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Benefício Social:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.beneficioSocial || _vm.detalhes.outroBeneficioSocial || 'Nenhum'))])])], 1), _c('hr'), _c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CheckSquareIcon"
    }
  }), _vm._v(" Bens e Eletrodomésticos ")], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiEnergiaEletrica === 'Sim' || _vm.detalhes.possuiEnergiaEletrica === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiEnergiaEletrica === 'Sim' || _vm.detalhes.possuiEnergiaEletrica === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Energia Elétrica ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiInternet === 'Sim' || _vm.detalhes.possuiInternet === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiInternet === 'Sim' || _vm.detalhes.possuiInternet === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Internet ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiComputador === 'Sim' || _vm.detalhes.possuiComputador === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiComputador === 'Sim' || _vm.detalhes.possuiComputador === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Computador ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiGeladeira === 'Sim' || _vm.detalhes.possuiGeladeira === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiGeladeira === 'Sim' || _vm.detalhes.possuiGeladeira === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Geladeira ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiVentilador === 'Sim' || _vm.detalhes.possuiVentilador === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiVentilador === 'Sim' || _vm.detalhes.possuiVentilador === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Ventilador ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiLavadoraRoupa === 'Sim' || _vm.detalhes.possuiLavadoraRoupa === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiLavadoraRoupa === 'Sim' || _vm.detalhes.possuiLavadoraRoupa === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Lavadora de Roupa ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiTelevisao === 'Sim' || _vm.detalhes.possuiTelevisao === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiTelevisao === 'Sim' || _vm.detalhes.possuiTelevisao === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Televisão ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiTelefone === 'Sim' || _vm.detalhes.possuiTelefone === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiTelefone === 'Sim' || _vm.detalhes.possuiTelefone === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Telefone / Celular ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiRadio === 'Sim' || _vm.detalhes.possuiRadio === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiRadio === 'Sim' || _vm.detalhes.possuiRadio === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Rádio ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiAutomovel === 'Sim' || _vm.detalhes.possuiAutomovel === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiAutomovel === 'Sim' || _vm.detalhes.possuiAutomovel === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Automóvel ")], 1), _c('b-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": "6",
      "md": "4"
    }
  }, [_c('feather-icon', {
    class: _vm.detalhes.possuiMoto === 'Sim' || _vm.detalhes.possuiMoto === 'true' ? 'text-success mr-50' : 'text-danger mr-50',
    attrs: {
      "icon": _vm.detalhes.possuiMoto === 'Sim' || _vm.detalhes.possuiMoto === 'true' ? 'Check' : 'X'
    }
  }), _vm._v(" Motocicleta ")], 1)], 1)], 1)]), _c('b-tab', {
    attrs: {
      "title": "Arboviroses e Prevenção"
    }
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ActivityIcon"
    }
  }), _vm._v(" Histórico Pessoal de Arboviroses ")], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Teve Dengue:")]), _c('div', [_c('b-badge', {
    attrs: {
      "variant": _vm.detalhes.teveDengue === 'Sim' || _vm.detalhes.teveDengue === 'true' ? 'danger' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.detalhes.teveDengue || 'Não') + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Dengue Hemorrágica:")]), _c('div', [_c('b-badge', {
    attrs: {
      "variant": _vm.detalhes.teveDengueHemorragica === 'Sim' || _vm.detalhes.teveDengueHemorragica === 'true' ? 'danger' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.detalhes.teveDengueHemorragica || 'Não') + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Chikungunya:")]), _c('div', [_c('b-badge', {
    attrs: {
      "variant": _vm.detalhes.teveChikungunya === 'Sim' || _vm.detalhes.teveChikungunya === 'true' ? 'warning' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.detalhes.teveChikungunya || 'Não') + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Zika Vírus:")]), _c('div', [_c('b-badge', {
    attrs: {
      "variant": _vm.detalhes.teveZikaVirus === 'Sim' || _vm.detalhes.teveZikaVirus === 'true' ? 'info' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.detalhes.teveZikaVirus || 'Não') + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Febre Amarela:")]), _c('div', [_c('b-badge', {
    attrs: {
      "variant": _vm.detalhes.teveFebreAmarela === 'Sim' || _vm.detalhes.teveFebreAmarela === 'true' ? 'warning' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.detalhes.teveFebreAmarela || 'Não') + " ")])], 1)])], 1), _c('hr'), _c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UsersIcon"
    }
  }), _vm._v(" Histórico Familiar (Alguém em casa teve) ")], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Dengue em Casa:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.alguemCasaTeveDengue || 'Não'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Chikungunya em Casa:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.alguemCasaTeveChikungunya || 'Não'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Zika em Casa:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.alguemCasaTeveZikaVirus || 'Não'))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Febre Amarela em Casa:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.alguemCasaTeveFebreAmarela || 'Não'))])])], 1), _c('hr'), _c('h5', {
    staticClass: "text-primary mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ShieldIcon"
    }
  }), _vm._v(" Cuidados e Prevenção ")], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Usa proteção contra mosquitos:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.usaProtecaoMosquitos || '-'))]), _vm.detalhes.formaProtecaoMosquitos ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Formas: " + _vm._s(_vm.detalhes.formaProtecaoMosquitos) + " ")]) : _vm._e()]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Práticas de prevenção na residência:")]), _c('div', [_vm._v(_vm._s(_vm.detalhes.casaPrevencaoMosquitos || '-'))]), _vm.detalhes.formaCasaPrevencaoMosquitos ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Ações: " + _vm._s(_vm.detalhes.formaCasaPrevencaoMosquitos) + " ")]) : _vm._e()])], 1)], 1)])], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }